module.exports = __webpack_public_path__ + "img/cardBg.5c3ea30f.svg";